'use client';
import React, { useRef } from 'react';
import { ChipOutline, Divider, H2, Subtitle } from '@/components/atoms';
import { ButtonWithIcon } from '@/components/molecules';
import { Container, TitleLeftWrapper, TitleWrpper, Wrapper } from './Header.styled';
import { IBaseProps } from '@/types';
import useWindowScroll from 'beautiful-react-hooks/useWindowScroll';
import { useAtom } from 'jotai';
import { useRouter } from 'next/router';
import { nowViewComponentAtom } from '@/store';
import { useCommonParams } from '@/hooks';
import { MEDIA_SEQ } from '@/const';

const Header = (props: IBaseProps) => {
  const [, setNowViewComponent] = useAtom(nowViewComponentAtom);
  const {
    chip = '',
    ctaName = '',
    subTitle = '',
    needDivider = false,
    title,
    id,
    destinationUrl,
  } = props;
  const { mediaSeq, media } = useCommonParams();
  const ref = useRef<HTMLDivElement>(null);
  const handleScroll = useWindowScroll();
  const router = useRouter();
  const query = router.query;

  const handleClick = async () => {
    const url = mediaSeq === MEDIA_SEQ.KT ? `/${media}${destinationUrl}` : `${destinationUrl}`;
    delete query.media;
    delete query.page;
    await router.push({ pathname: `${url}`, query });
  };

  handleScroll(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      if (rect.top < 500) {
        setNowViewComponent(id ?? '');
      }
    }
  });

  return (
    <Container ref={ref} id={id}>
      {needDivider && <Divider />}
      <Wrapper divider={needDivider}>
        <TitleWrpper>
          <TitleLeftWrapper>
            {chip && <ChipOutline>{chip}</ChipOutline>}
            <H2 color="gray-800">{title}</H2>
          </TitleLeftWrapper>
          {ctaName && (
            <ButtonWithIcon onClick={handleClick} textLevel={8} iconName="chevronRight">
              {ctaName}
            </ButtonWithIcon>
          )}
        </TitleWrpper>
        {subTitle && (
          <Subtitle level={6} whiteSpaceWrap>
            {subTitle}
          </Subtitle>
        )}
      </Wrapper>
    </Container>
  );
};

export default React.memo(Header);
